/** Ticket visuals in the end-user's voice.
 *
 * The tones come from the shared map so a resolved ticket is the same green the
 * console uses; the wording is the portal's own, because "Awaiting your reply"
 * is what a requester needs to read and "Pending customer" is not.
 */
import { PRIORITY_TONE, STATUS_VARIANT } from '../../components/domain/ticketVisuals'
import { Badge } from '../../components/ui/badge'
import { cn } from '../../lib/utils'
import { PRIORITY_LABELS, STATUS_LABELS } from '../../lib/types'

export function StatusBadge({ status }: { status: string }) {
  return (
    <Badge variant={STATUS_VARIANT[status] ?? 'neutral'}>
      {STATUS_LABELS[status] ?? status}
    </Badge>
  )
}

export function PriorityBadge({ priority }: { priority: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded px-1.5 py-0.5 text-xs font-medium',
        PRIORITY_TONE[priority] ?? PRIORITY_TONE.p4,
      )}
    >
      {PRIORITY_LABELS[priority] ?? priority}
    </span>
  )
}
